import { classnames } from '@aibees/shared/utils';
import { TextFieldProps } from '@mui/material';
import { memo } from 'react';
import { useSearchListCardStore } from '../../store';
import * as Styled from './styles';
import * as SX from './sx';
import type { SearchCardListNameFilterProps as Props } from './types';

export const SearchCardListNameFilter = memo(({ className }: Props) => {
  const { setName, name } = useSearchListCardStore();

  const handleSearchChange: TextFieldProps['onChange'] = (e) => {
    setName(e.target.value);
  };
  return (
    <Styled.Wrapper
      className={classnames('SearchCardListNameFilter', className)}
      sx={SX.root}
      fullWidth
      autoComplete="off"
      size="small"
      placeholder="Type to search..."
      startIcon="search"
      value={name}
      onChange={handleSearchChange}
    />
  );
});

SearchCardListNameFilter.displayName = 'SearchCardListNameFilter';
